// extracted by mini-css-extract-plugin
module.exports = {"base":"passwordReset_base__1FgwS","verticalLine":"passwordReset_verticalLine__2WlOq","successMessage":"passwordReset_successMessage__1wcI0","error":"passwordReset_error__1ZbIj"};